let formValidateVariantState;

function validatePlaylistCreateForm(){
    const playlistCreateState = $('.js-playlist-create-state');
    const playlistSelectState = $('.js-playlist-select-state');

    const form = document.querySelector('.js-playlist-create-form');
    const playlistNameInput = document.querySelector('.js-playlist-name-field');
    playlistNameInput.value = playlistName;
    const playlistNameError = document.querySelector('.js-playlist-name-sign');
    
    let playlistNameDefaultState = true;
    
    $(playlistNameInput).on('blur', function(){
        if($(this).val() != '' && playlistNameDefaultState == true){
            playlistNameDefaultState = false;
        }
    });

    playlistNameInput.addEventListener('input', () => {
        if(!playlistNameDefaultState){
            validatePlaylistName();
        }
    });
    
    /* IF WE CREATE NEW PLAYLIST */
    function validatePlaylistName(){
        const name = playlistNameInput.value.trim();
    
        if (name == '') {
            showErrorMessage(playlistNameError, 'This field is required.');
            return false;
        }

        hideErrorMessage(playlistNameError);
        return true;
    }

    /* IF WE SELECT FROM EXISTING PLAYLISTS */
    function validatePlaylistSelect(){
        const select = $('#playlist-select');
        if(select.val() == null || select.val() == ''){
            return false;
        }
        return true;
    }

    $(form).submit(function(e) {
        e.preventDefault();
    
        if (
            (playlistCreateState.hasClass('active') && validatePlaylistName())
            || (playlistSelectState.hasClass('active') && validatePlaylistSelect())
        ) {
            $(this).off('submit').on('submit', function(){
                return true;
            });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
}

runIfElementExist(validatePlaylistCreateForm, '.js-playlist-create-form');
